/*
 * Wrapped in an IIFE: this loads as a plain <script defer> and can
 * share a page with other faq-pattern scripts that also declare a
 * top-level `init` (e.g. home-quiz-picker.js on the homepage).
 * Without isolation the second script to parse throws "Identifier
 * 'init' has already been declared" and never runs.
 */
(() => {
class HeroAppFAQ {
  constructor(root) {
    this.root = root;
    this.items = Array.from(root.querySelectorAll('.hh-faq__item'));
    this.items.forEach((item) => {
      const trigger = item.querySelector('.hh-faq__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', () => this.toggle(item));
    });
  }

  toggle(item) {
    const isOpen = item.classList.contains('is-open');
    this.items.forEach((other) => {
      if (other !== item && other.classList.contains('is-open')) {
        this.close(other);
      }
    });
    if (isOpen) {
      this.close(item);
    } else {
      this.open(item);
    }
  }

  open(item) {
    item.classList.add('is-open');
    const trigger = item.querySelector('.hh-faq__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    this.scrollIntoViewIfAbove(item);
  }

  /*
   * When opening an item pushes/leaves its top edge above the viewport —
   * typically because a taller open item above it just collapsed — bring the
   * top back into view once the panel transitions (0.32s) have settled.
   *
   * The item's own scroll-margin-top doubles as the threshold, so a page with
   * a sticky header can opt into "hidden under the header counts as hidden"
   * by declaring it in CSS (scrollIntoView honours the same margin when
   * landing). Pages that declare nothing keep a 0px threshold, i.e. only a
   * genuinely off-screen top triggers a scroll.
   */
  scrollIntoViewIfAbove(item) {
    globalThis.setTimeout(() => {
      if (!item.classList.contains('is-open')) return;
      const margin = Number.parseFloat(globalThis.getComputedStyle(item).scrollMarginTop) || 0;
      if (item.getBoundingClientRect().top >= margin) return;
      const reduce = globalThis.window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      item.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }, 360);
  }

  close(item) {
    item.classList.remove('is-open');
    const trigger = item.querySelector('.hh-faq__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }
}

const init = () => {
  document.querySelectorAll('[data-heroapp-faq]').forEach((root) => {
    if (root.dataset.heroappFaqReady === 'true') return;
    root.dataset.heroappFaqReady = 'true';
    new HeroAppFAQ(root);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
})();
